import React from "react";
import { StyledLink } from "../../../styled-mui";

interface SmartLinkProps {
  to: string;
  extraProps?: Record<string, any>;
  isExternal?: boolean;
  onClick?: () => any;
  children: React.ReactNode | React.ReactNode[];
  styles?: React.CSSProperties;
  className?: string;
}

/**
 * This component handles redirecting of internal links and external links
 */
const SmartLink: React.FC<SmartLinkProps> = ({
  to,
  extraProps,
  isExternal = false,
  onClick,
  children,
  styles = {},
  className = "",
}) =>
  isExternal ? (
    <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      style={styles}
      onClick={() => onClick && onClick()}
      className={className}
      {...extraProps}>
      {children}
    </a>
  ) : (
    <StyledLink to={to} style={styles} className={className} onClick={() => onClick && onClick()} {...extraProps}>
      {children}
    </StyledLink>
  );

export default SmartLink;